// src/components/ProfileCard.jsx
import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaGlobe, FaPhoneAlt, FaWhatsapp, FaEnvelope, FaCrown, FaGoogle } from 'react-icons/fa';
import '../css/ProfileCard.css';
import howner from "../assets/pgimages/WhatsApp Image 2025-07-08 at 2.45.05 PM.jpeg"

const ProfileCard = () => {
  return (
    <div className="profile-card-simple">
      {/* Section Heading */}
      <div className="profile-heading-simple">
        <div className="profile-icon">
          <FaCrown />
        </div>
        <h1>Meet Our <span>Founder</span></h1>
      </div>

      <div className="profile-content-simple">
        <div className="profile-image-simple">
          <img
            src={howner}
            alt="Mrs. Sweta Rita"
          />
        </div>
        
        <div className="profile-info-simple">
          <h2>Mrs. Sweta Rita</h2>
          <p className="profile-title">Owner & Founder</p>
          
          <div className="profile-description-simple">
            <p>
              Welcome to our premium <strong>girls-only accommodation</strong> – a safe, peaceful, and fully-facilitated environment designed specifically for female students and working women. We provide a clean, secure, and homely atmosphere with 24/7 safety and CCTV surveillance.
            </p>
            <p>
              Our rooms are spacious, well-ventilated, and furnished with individual beds, wardrobes, study tables, and Wi-Fi. Options for single, double, or triple sharing are available as per your preference. We also offer healthy home-cooked meals, RO drinking water, laundry service, and regular housekeeping.
            </p>
            <p>
              As the owner, I personally ensure that each girl feels at home here. We focus on comfort, cleanliness, and a friendly atmosphere where girls can feel safe, study in peace, and enjoy their time without any worry. Your safety and well-being is our top priority.
            </p>
          </div>

          <div className="profile-contact-simple">
            <div className="contact-item">
              <FaPhoneAlt />
              <a href="tel:+918879779777">+91 88797-79777</a>
            </div>
            <div className="contact-item">
              <FaWhatsapp />
              <a href="https://wa.me/918879779777" target="_blank" rel="noopener noreferrer">+91 88797-79777</a>
            </div>
            <div className="contact-item">
              <FaEnvelope />
              <a href="mailto:swetarita25786@gmail.com">swetarita25786@gmail.com</a>
            </div>
          </div>

          <div className="profile-social-simple">
            <a href="https://www.facebook.com/profile.php?id=61579151297192" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a> */}
            <a href="https://www.instagram.com/no_brokerage_payingguest/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://share.google/fPIgRUSA8uh983Pv4" target="_blank" rel="noopener noreferrer">
              <FaGoogle />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;